export default "__VITE_ASSET__B1IRM$xh__"